import React from 'react'

const JuegoIlegal = () => {
  return (
    <div className='container-fluid py-5 fondotransparente5'>
      <div className='margenazul pb-1'>
      <h2 className='botonbordeazul text-white px-5 py-3 mb-4'>Juego Ilegal</h2>
      <br/>
      <center>
        <div className=''>
          {/* Media query para dispositivos móviles */}
          <img
            className='img-fluid mobile-image'
            src='./img/Denuncia_Juego_Ilegal_Redes_Historia.jpg'
            alt='Imagen para dispositivos móviles'
          />

          {/* Media query para escritorio */}
          <img
            className='img-fluid desktop-image'
            src='./img/Denuncia_Juego_Ilegal_Redes_Slider_Web.jpg'
            alt='Imagen para escritorio'
          />
        </div>
      </center>
      <p>Es toda actividad lúdica relacionada al azar, aquel que no está autorizado ni regulado por el estado provincial, comprendiendo en esto a cualquier persona física o jurídica que organizara, explotara, administrara y/o comercializara juegos de azar, captación de apuestas y/o actividades conexas, no autorizadas por la Autoridad de Aplicación en su jurisdicción-</p>
      <h4>¿CUÁL ES LA AUTORIDAD DE APLICACIÓN DE LOS JUEGOS DE AZAR? </h4>

      <p>En el Artículo 121° de la Constitución Nacional; se establece que la facultad de control y regulación de los juegos de azar es una facultad no delegada por las provincias a la Nación. Por lo que cada provincia tiene la potestad de autorizar regular los juegos dentro de su territorio. En este contexto para explotar, administrar o comercializar juegos de azar en la Provincia de Jujuy, es necesario disponer de título habilitante autorización, o licencia otorgada por la Autoridad competente.  En nuestra provincia el organismo competente es el INTITUTO DE JUEGOS DE AZAR DE JUJUY (INPROJUY) y únicamente pueden ofrecerse aquellos juegos que están regulados en cada jurisdicción.</p>
      

      <h4>¿PORQUE ES UN DELITO?</h4>
      <p>La ley 27.346 suma un artículo 301 bis del Código Penal de la Nación en el que se tipifica al juego clandestino como delito penal, determinando que se aplicará una “pena de cárcel de tres (3) a seis (6) años, a quien explotare, administrare, operare o de cualquier manera organizare, por sí o a través de terceros, cualquier modalidad o sistema de captación de juegos de azar sin contar con la autorización pertinente emanada de la autoridad jurisdiccional competente”. Dentro de la misión del Instituto Provincial de Juegos de Azar, se encuentra el control de los juegos de azar, destreza, apuestas mutuas y actividades relacionada.</p>
        <h4>PORQUE JUGAR EN SITIOS AUTORIZADOS</h4>
      <p>Es importante entender y transmitir al público general, que el jugar en sitios autorizados por el Instituto Provincial de Juegos de Azar de la Provincia de Jujuy, tiene beneficios para los tres pilares que intervienen en estas actividades: los apostadores, los empresarios y el estado, como así también apostar en sitios oficiales resulta seguro y legal ya que cuenta con las siguientes ventajas para los jugadores:</p>
      </div>
      <div className='margenrojo jus'>
      <ul>
        <li>Cada Juego cuenta con sus Reglas Claras y transparentes.</li>
        <li>Tienen la seguridad de pagos, cobros de premios y depósitos.</li>
        <li>Están amparados por la Protección de los derechos de los apostadores.</li>
        <li>Identificación del usurario en sitios on line y salas tragamonedas físicas.</li>
        <li>Cuenta con herramientas de Juego Responsable con el objetivo de prevenir el desarrollo de conductas problemáticas.</li>
      </ul>
      <p>Para lograr una actividad lúdica transparente, donde el rol estatal garantice que la misma se desarrolle de acuerdo al marco legal vigente, teniendo en cuenta principalmente el destino social de los fondos.</p>

      <p>Colabora con el <strong>Juego Seguro, Legal y Responsable</strong> realizando tu denuncia sobre juego ilegal o sitios de juegos clandestinos de manera anónima al teléfono 3884136280 o completando el siguiente <a href="https://inprojuy.gob.ar/#/denuncias"><strong><u>formulario</u></strong></a> </p>
      </div>

    </div>
  )
}

export default JuegoIlegal